import { render, staticRenderFns } from "./DriverEditFiles.vue?vue&type=template&id=5c6bafc6&"
import script from "./DriverEditFiles.vue?vue&type=script&lang=js&"
export * from "./DriverEditFiles.vue?vue&type=script&lang=js&"
import style0 from "./DriverEditFiles.vue?vue&type=style&index=0&id=5c6bafc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports